import { FormattedMessage, useIntl } from 'react-intl';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import { getRouteApi, useNavigate } from '@tanstack/react-router';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import CloseIcon from '@mui/icons-material/Close';

import TurnReportAttendees from '~/components/TurnReportAttendees';
import ContentView from '~/components/ContentView';
import { useTurnReport } from '~/hooks/api/useTurnReport';
import { useEditTurnReport } from '~/hooks/api/useEditTurnReport';
import messages from './messages';

const route = getRouteApi('/turn-reports/$turnReportId');

export const TurnReportEdit = () => {
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();

  const navigate = useNavigate();
  const { turnReportId } = route.useParams();
  const search = route.useSearch();

  const { data: turnReport, isLoading } = useTurnReport({
    id: parseInt(turnReportId, 10),
    expand: ['turn.publisher', 'turn.shift'],
  });

  const gotoTurnReportsList = () => {
    navigate({ to: search.from || '/turn-reports' });
  };
  const editTurnReportMutation = useEditTurnReport({
    onSuccess: () => {
      showSnackbar({
        message: intl.formatMessage(messages.editSuccess),
      });
    },
    onError: () => {
      showSnackbar({
        message: intl.formatMessage(messages.editFailure),
      });
    },
  });
  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <IconButton
              color="inherit"
              onClick={gotoTurnReportsList}
              size="large"
            >
              <CloseIcon data-testid="close" />
            </IconButton>
            <Typography variant="h6" sx={{ ml: 2, flexGrow: 1 }}>
              <FormattedMessage {...messages.editTurnReportHeader} />
            </Typography>
          </Toolbar>
        </AppBar>
      }
      isLoading={isLoading}
    >
      {isLoading || !turnReport ? (
        <CircularProgress size={60} />
      ) : (
        <TurnReportAttendees
          turnReport={turnReport}
          onSubmit={editTurnReportMutation.mutate}
        />
      )}
    </ContentView>
  );
};

export default TurnReportEdit;
